import React, { useEffect, useState } from 'react';
import { Timer } from 'lucide-react';
export function UrgencyBar() {
  // 14 minutes and 59 seconds in seconds
  const [timeLeft, setTimeLeft] = useState(14 * 60 + 59);
  useEffect(() => {
    if (timeLeft <= 0) return;
    const timerId = setInterval(() => {
      setTimeLeft(prev => prev - 1);
    }, 1000);
    return () => clearInterval(timerId);
  }, [timeLeft]);
  const minutes = Math.floor(timeLeft / 60);
  const seconds = timeLeft % 60;
  const formattedTime = `${minutes.toString().padStart(2, '0')}:${seconds.toString().padStart(2, '0')}`;
  return <div className="sticky top-0 z-50 bg-alert text-white py-3 px-4 shadow-md" data-id="element-192">
      <div className="max-w-6xl mx-auto flex flex-col md:flex-row items-center justify-center text-center md:text-left text-sm md:text-base font-medium" data-id="element-193">
        <span data-id="element-194">
          ¡ATENCIÓN! Promo especial por el Mes de la Salud Latina expira cuando
          el contador llegue a cero:
        </span>
        <div className="flex items-center mt-2 md:mt-0 md:ml-4 bg-alert-dark px-3 py-1 rounded-md font-mono text-lg font-bold" data-id="element-195">
          <Timer className="w-5 h-5 mr-2 animate-pulse" data-id="element-196" />
          {formattedTime}
        </div>
      </div>
    </div>;
}